import { datadogLogs } from '@datadog/browser-logs';
import { getEnv } from '../utils/environment';
import { PlanCode } from '../../interfaces/IPlanCode';
import { simpleFetch } from './customFetch';

// TODO: add fffsocial to growth-api plan codes
const GET_SUBSCRIPTION_PLANS = '/api/1/subscription/plans';
const GET_EXCHANGE_RATE = '/exchange-rates?baseCurrency=USD&targetCurrency=GBP';

type SubscriptionPlansTypes = PlanCode;

export type SubscriptionPlans = {
  [plan in SubscriptionPlansTypes]: {
    name: string;
    description: string;
    price: {
      amount: number;
      amountInCents: number;
      currency: string;
    } | null;
    boxPrice: {
      amount: number;
      amountInCents: number;
      currency: string;
    } | null;
    termUnit: string;
    termLength: number;
  };
};

const getPlans = () =>
  simpleFetch({
    uri: '',
    options: {},
    baseUrl: getEnv().localizationEndpoint + GET_SUBSCRIPTION_PLANS,
  });

const getPrices: () => Promise<SubscriptionPlans> = () =>
  getPlans()
    .then((res) => res as SubscriptionPlans)
    .catch((err) => {
      datadogLogs.logger.error(
        'Error fetching subscription plans from localization-api in fff-payments',
        {},
        err,
      );
      throw new Error(err);
    });

const getExchangeRate: () => Promise<number> = () =>
  simpleFetch({
    uri: '',
    options: {},
    baseUrl: getEnv().localizationEndpoint + GET_EXCHANGE_RATE,
  });

export { getPrices, getExchangeRate };
